import { callAPI } from "../config/AxiosTemplate";

import { API, API_RESPONSE_STATUS_CODES } from "../Utils/Constants";

export const getProfileAction = (username, callback) => {
  callAPI("GetProfile", API.getProfile + username, "GET", {}, (apiResponse) => {
    if (apiResponse.data.status === API_RESPONSE_STATUS_CODES.SUCCESS) {
      callback(apiResponse.data.status, apiResponse.data.data);
    } else {
      callback(apiResponse.data.status, null);
    }
  });
};
